import { createSlice } from '@reduxjs/toolkit'

interface settingsSlice {
    data: { settings?: { threshold_score?: number; linkedIn_score?: number, is_free_trial_managed_by_stripe?: boolean } }
    loading: boolean
}

const initialState: settingsSlice = {
    data: {},
    loading: false
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState: initialState,
    reducers: {
        setSettingsData: (state, action) => {
            state.data = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    }
})

export const { setSettingsData, setLoading } = settingsSlice.actions
export default settingsSlice.reducer
